
import { Card, CardContent, Typography, useTheme } from "@mui/material";
import RadioQuestion from "./QuestionTypes/RadioQuestion";
import CheckboxQuestion from "./QuestionTypes/CheckboxQuestion";
import DropdownQuestion from "./QuestionTypes/DropdownQuestion";
import TextQuestion from "./QuestionTypes/TextQuestion";
import DateQuestion from "./QuestionTypes/DateQuestion";
import TimeQuestion from "./QuestionTypes/TimeQuestion";
import SignatureQuestion from "./QuestionTypes/SignatureQuestion";
import FreeTextQuestion from "./QuestionTypes/FreeTextQuestion";
import { QuestionnaireItemType } from "../../../_helpers";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

const RenderQuestion = ({
  q,
  sectionIndex,
  handleChange,
  formData,
  setFormData,
  isDisabled = false,
  error,
  handleFiles,
  errors
  }) => {
  const theme = useTheme();
  const { t } = useTranslation()
  const commonProps = {
    q,
    sectionIndex,
    handleChange,
    error,
    formData,
    setFormData,
    isDisabled,
    handleFiles,
  }

  const renderByType = () => {
    switch (q.type) {
      case QuestionnaireItemType.Radio:
        return <RadioQuestion {...commonProps} />;
      case QuestionnaireItemType.Checkbox:
        return <CheckboxQuestion {...commonProps} />;
      case QuestionnaireItemType.Dropdown:
        return <DropdownQuestion {...commonProps} />;
      case QuestionnaireItemType.ShortText:
      case QuestionnaireItemType.Paragraph:
        return <TextQuestion {...commonProps} />;
      case QuestionnaireItemType.Date:
        return <DateQuestion {...commonProps} />;
      case QuestionnaireItemType.Time:
        return <TimeQuestion {...commonProps} />;
      case QuestionnaireItemType.Signature:
        return <SignatureQuestion {...commonProps} />;
      case QuestionnaireItemType.FreeText:
        return <FreeTextQuestion {...commonProps} />;
      default:
        return null;
    }
  };
  const ref = useRef(null);
  const firstErrorKey = errors?.keys().next().value;
  const currentKey = `${sectionIndex}-${q.id}`;
  const isFirstError = firstErrorKey === currentKey;

  useEffect(() => {
    if (isFirstError && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [isFirstError]);

  return (
    <Card
      ref={ref} 
      sx={{
        width: "100%",
        maxWidth: 700,
        borderRadius: 2,
        boxShadow: 1,
        mb: 3,
        border: error
          ? `1px solid ${theme.palette.error.main}`
          : "1px solid transparent",
      }}

    >
      <CardContent>
        {q.type !== QuestionnaireItemType.FreeText && (
          <Typography
            variant="subtitle1"
            sx={{ mb: 1, display: "flex", alignItems: "center" }}
          >
            {q.text || t('questionnaire.form.question')}
            {q.required && (
              <Typography component="span" color="error" sx={{ ml: 0.5 }}>
                *
              </Typography>
            )}
          </Typography>
        )}
        {renderByType()}
      </CardContent>
    </Card>
  );
};

export default RenderQuestion;
